import { getStorage, setStorage } from '@/utils/storage'

const state = {
  sidebar: {
    opened: getStorage('sidebarStatus') ? !!getStorage('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: getStorage('size') || 'medium',
  seniorSearch: getStorage('seniorSearch') || [], //条件组
  addressList: getStorage('addressList') || [], //地址
  industryList: getStorage('industryList') || [], //行业
  channelList: getStorage('channelList') || [], //渠道
  countryList: getStorage('countryList') || [], //渠道
}

const getters = {
  sidebar: (state) => state.sidebar,
  device: (state) => state.device,
  size: (state) => state.size,
  seniorSearch: (state) => state.seniorSearch,
  addressList: (state) => state.addressList,
  industryList: (state) => state.industryList,
  channelList: (state) => state.channelList,
  countryList: (state) => state.countryList,
}

const mutations = {
  toggleSideBar: state => {
    const opened = state.sidebar.opened ? 1 : 0
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    setStorage('sidebarStatus', opened)
  },
  closeSideBar: (state, withoutAnimation) => {
    setStorage('sidebarStatus', false)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  toggleDevice: (state, device) => {
    state.device = device
  },
  setSize: (state, size) => {
    state.size = size
    setStorage('size', size)
  },
  setSeniorSearch: (state, seniorSearch) => {
    state.seniorSearch = seniorSearch
    setStorage('seniorSearch', seniorSearch)
  },
  setAddressList: (state, addressList) => {
    state.addressList = addressList
    setStorage('addressList', addressList)
  },
  setIndustryList: (state, industryList) => {
    state.industryList = industryList
    setStorage('industryList', industryList)
  },
  setChannelList: (state, channelList) => {
    state.channelList = channelList
    setStorage('channelList', channelList)
  },
  setCountryList: (state, countryList) => {
    state.countryList = countryList
    setStorage('countryList', countryList)
  },
}

const actions = {
  toggleSideBar ({ commit }) {
    commit('toggleSideBar')
  },
  closeSideBar ({ commit }, { withoutAnimation }) {
    commit('closeSideBar', withoutAnimation)
  },
  toggleDevice ({ commit }, device) {
    commit('toggleDevice', device)
  },
  setSize ({ commit }, size) {
    commit('setSize', size)
  },
  setSeniorSearch({ commit }, seniorSearch) {
    commit('setSeniorSearch', seniorSearch)
  },
  setAddressList({ commit }, addressList) {
    commit('setAddressList', addressList)
  },
  setIndustryList({ commit }, industryList) {
    commit('setIndustryList', industryList)
  },
  setChannelList({ commit }, channelList) {
    commit('setChannelList', channelList)
  },
  setCountryList({ commit }, countryList) {
    commit('setCountryList', countryList)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js